/* Kidsy landing template only: tags the content sections for reveal / zoom / lift and runs the scroll reveal.
   Loaded by sections/main-collection-product-grid-landing.liquid. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function tag() {
    // Sections below the grid fade up as they arrive (the top of the page is already in view)
    var reveal = $$('.kidsy-cg-section, .kidsy-cmp-section, .kidsy-insp-section, .kidsy-pc-section, .cust-testimonial--section, .shopify-section:has(.collapsible-content)');
    $$('.kidsy-cg__card, .kidsy-pc__card, .kidsy-pc__kidsy, .kidsy-cmp__table').forEach(function (c) { c.classList.add('kidsy-lift'); });
    $$('.kidsy-insp__media, .kidsy-pc__image').forEach(function (m) { m.classList.add('kidsy-zoom'); });

    // Inspection points: hover, focus or tap highlights a point and zooms the photo
    var photo = document.querySelector('.kidsy-insp__media img');
    var points = $$('.kidsy-insp__item');
    points.forEach(function (p) {
      p.classList.add('kidsy-point');
      p.setAttribute('tabindex', '0');
      var on = function () {
        points.forEach(function (x) { x.classList.remove('is-active'); });
        p.classList.add('is-active');
        if (photo) photo.style.transform = 'scale(1.06)';
      };
      var off = function () { p.classList.remove('is-active'); if (photo) photo.style.transform = ''; };
      p.addEventListener('mouseenter', on); p.addEventListener('focus', on); p.addEventListener('click', on);
      p.addEventListener('mouseleave', off); p.addEventListener('blur', off);
    });

    if (reduce) return;
    reveal.forEach(function (s) { s.classList.add('kidsy-reveal'); });

    var show = function (s) { s.classList.add('is-visible'); };
    var check = function () {
      var h = window.innerHeight;
      reveal.forEach(function (s) { if (s.classList.contains('is-visible')) return; var r = s.getBoundingClientRect(); if (r.top < h * 0.92 && r.bottom > 0) show(s); else if (r.bottom <= 0) show(s); });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      reveal.forEach(function (s) { io.observe(s); });
    }
    // Fallback: anything in or above the viewport is shown on scroll, so a section can never stay hidden
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tag); else tag();
})();

/* Circles filter the grid in place (no page load): fetch only the grid section for the circle's URL and swap it in. */
(function () {
  function gridSection() {
    var el = document.querySelector('.shopify-section .main-collection');
    return el ? el.closest('.shopify-section') : null;
  }
  function withParams(href) {
    var url = new URL(href, window.location.origin);
    var cur = new URLSearchParams(window.location.search);
    ['view', 'preview_theme_id'].forEach(function (k) { if (cur.get(k) && !url.searchParams.get(k)) url.searchParams.set(k, cur.get(k)); });
    return url;
  }
  function load(href, push) {
    var sec = gridSection();
    if (!sec) { window.location.href = href; return; }
    var id = sec.id.replace('shopify-section-', '');
    var url = withParams(href);
    var fetchUrl = new URL(url.toString()); fetchUrl.searchParams.set('section_id', id);
    sec.style.transition = 'opacity .2s ease'; sec.style.opacity = '0.4';
    fetch(fetchUrl.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(sec.id) || doc.querySelector('.shopify-section') || doc.body.firstElementChild;
        sec.innerHTML = fresh ? fresh.innerHTML : html;
        sec.querySelectorAll('script').forEach(function (old) { var s = document.createElement('script'); [].forEach.call(old.attributes, function (a) { s.setAttribute(a.name, a.value); }); s.textContent = old.textContent; old.replaceWith(s); });
        sec.style.opacity = '1';
        if (push) history.pushState({ kidsyCircle: url.toString() }, '', url.pathname + url.search);
        var top = sec.getBoundingClientRect().top + window.scrollY - 120;
        window.scrollTo({ top: top, behavior: 'smooth' });
      })
      .catch(function () { window.location.href = url.toString(); });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.subcollection-carousel-wrapper a.collection-card');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    document.querySelectorAll('.subcollection-carousel-wrapper .collection-card.is-active').forEach(function (x) { x.classList.remove('is-active'); });
    var already = a.getAttribute('href') && window.location.href.indexOf(a.getAttribute('href').split('?')[1] || a.getAttribute('href')) > -1;
    if (already) { load(window.location.pathname.replace(/\/wagon$/, '') , true); return; }
    a.classList.add('is-active');
    load(a.getAttribute('href'), true);
  });
  window.addEventListener('popstate', function () { load(window.location.href, false); });
})();
/* Load more (landing grid): append the next page's products in place instead of infinite scroll. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.kidsy-load-more__button');
    if (!btn || btn.disabled) return;
    var sec = btn.closest('.shopify-section');
    var grid = sec && sec.querySelector('#product-grid');
    if (!grid) return;
    var url = new URL(btn.getAttribute('data-next-url'), window.location.origin);
    var cur = new URLSearchParams(window.location.search);
    ['view', 'preview_theme_id'].forEach(function (k) { if (cur.get(k) && !url.searchParams.get(k)) url.searchParams.set(k, cur.get(k)); });
    url.searchParams.set('section_id', sec.id.replace('shopify-section-', ''));
    var label = btn.textContent; btn.disabled = true; btn.classList.add('is-loading'); btn.textContent = 'Loading…';
    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('#product-grid > .grid__item');
        items.forEach(function (li) { li.classList.remove('scroll-trigger', 'animate--slide-in'); li.classList.add('kidsy-new-item'); grid.appendChild(li); });
        var shown = sec.querySelector('[data-kidsy-shown]');
        if (shown) shown.textContent = grid.querySelectorAll('.grid__item').length;
        var next = doc.querySelector('.kidsy-load-more__button');
        if (next) { btn.setAttribute('data-next-url', next.getAttribute('data-next-url')); btn.disabled = false; btn.classList.remove('is-loading'); btn.textContent = label; }
        else { btn.remove(); }
      })
      .catch(function () { btn.disabled = false; btn.classList.remove('is-loading'); btn.textContent = label; });
  });
})();